import { Flex } from '@mantine/core'
import { createFormContext } from '@mantine/form'

import { useQueryGetUserLogged } from '@flecto/core/shared'
import { type CoreUser, type CoreUserPayload, } from '@flecto/types'

import { useFormProfileAccount } from '../../hooks/useFormProfileAccount'
import { CardAvatar } from './CardAvatar'
import { CardBasicInfo } from './CardBasicInfo'

export const [FormProvider, useFormContext, useForm] =
  createFormContext<Partial<CoreUserPayload & CoreUser & { avatar_image_url: string }>>()

type FormProfileAccountProps = {
  id?: string
  onChangeLoading?: (loading: boolean) => void
  onSuccess?: () => void
}

export function FormProfileAccount({
  onChangeLoading,
  ...props
}: FormProfileAccountProps) {
  const { data: user } = useQueryGetUserLogged()
  const { form, submit } = useFormProfileAccount({ user })

  return (
    <FormProvider form={form}>
      <form {...props} onSubmit={form.onSubmit((values) => submit(values))}>
        <Flex direction='column' gap='lg'>
          <CardAvatar />
          <CardBasicInfo />
        </Flex>
      </form>
    </FormProvider>
  )
}
